/* eslint-disable no-unused-expressions */
import { Autocomplete, Checkbox, TextField } from '@mui/material';
import { createFilterOptions } from '@mui/material/Autocomplete';

function MultiSelectAll({
  options,
  value,
  onChange,
  allSelected,
  labelOption,
  label,
  size = 'small',
  error,
  helperText,
  renderOptionLabel,
  labelSelectAllButtonFilterOptions,
  labelCustomRenderOption,
  ...rest
}) {
  const handleToggleOption = (selectedOps) => onChange(selectedOps);
  const handleClearOptions = () => onChange([]);

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      onChange(options);
    } else {
      handleClearOptions();
    }
  };

  const handleToggleSelectAll = () => {
    handleSelectAll && handleSelectAll(!allSelected);
  };

  const handleChange = (event, selectedOps, reason) => {
    if (reason === 'selectOption' || reason === 'removeOption') {
      if (
        selectedOps.find((option) => option[labelOption] === 'Selecionar todos')
      ) {
        handleToggleSelectAll();
        const result = options.filter(
          (el) => el[labelOption] !== 'Selecionar todos'
        );
        return onChange(result);
      }
      handleToggleOption && handleToggleOption(selectedOps);
      return onChange(selectedOps);
    }
    if (reason === 'clear') {
      handleClearOptions && handleClearOptions();
    }
  };

  const filter = createFilterOptions();

  return (
    <Autocomplete
      sx={{ minWidth: '200px', borderRadius: '18px' }}
      size={size}
      multiple
      noOptionsText="Sem opções"
      options={options}
      value={value}
      disableCloseOnSelect
      filterOptions={(op, params) => {
        const filtered = filter(op, params);
        const filterOptionsLabel = labelSelectAllButtonFilterOptions || {
          [labelOption]: 'Selecionar todos',
        };
        return [{ key: 0, ...filterOptionsLabel }, ...filtered];
      }}
      onChange={handleChange}
      getOptionLabel={(option) => option[labelOption]}
      renderOption={(props, option, { selected }) => {
        const selectAllProps =
          option[labelOption] === 'Selecionar todos'
            ? { checked: allSelected }
            : {};

        return (
          <li {...props}>
            <Checkbox checked={selected} {...selectAllProps} />
            {renderOptionLabel
              ? renderOptionLabel(option)
              : option[labelOption]}
          </li>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          helperText={helperText}
          label={label}
          InputProps={{
            ...params.InputProps,
            sx: {
              borderRadius: '18px',
            },
          }}
        />
      )}
      {...rest}
    />
  );
}

export default MultiSelectAll;
